module.exports = __webpack_public_path__ + "img/VERSION.4c136c04.png";